import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/my-clans")({
  component: RouteComponent,
});

function RouteComponent()
{
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-4">My Clans</h1>
      <p className="text-muted-foreground">Clans content will be here</p>
    </div>
  );
}
